function showCFPT2()
      {    
        var qBuild = '<div id="simpleList" class="list-group" style="top: 500px;>';

        for (i = 0; i < listNoStim[trialRow]; i++) {
            qBuild += '<div class="Image" id="item_' + (i+1) + '"><img src="' + images[i+1][trialRow].src + '"></div>';
        }

        qBuild += '</div>';
        $('#imageHolderCFPT').append(qBuild);

        Sortable.create(simpleList, { /* options */ });
        document.getElementById("simpleList").style.top = (canvasHeight/2 - maxImageHeight/2 - borderImage + verticalShift) + "px";

      }